// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { btrTestnet as _btrTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the btrTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 200810
 * Chain Name: Bitlayer Testnet
 * Default Block Explorer: https://testnet.btrscan.com
 * Default RPC URL: https://testnet-rpc.bitlayer.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { btrTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: btrTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const btrTestnet = createCommon({
	..._btrTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
